import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Checkbox from '@mui/material/Checkbox';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { InputBase } from '@mui/material';
import {
  Box,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { makeStyles, styled } from '@mui/styles';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { TabPanel } from 'component/OwnerCard/OwnerCard';
import {
  paddTop10,
  poppins300,
  poppins400,
  poppins500,
  poppins600,
} from 'theme/common.style';
// import { ReactComponent as Location } from "assets/icons/location.svg";
import { ReactComponent as FeedbackProfile } from 'assets/icons/feedback-profile.svg';
import { ReactComponent as CrossEllipse } from 'assets/icons/CrossEllipse.svg';
import { loginEmailCont } from 'component/Login/Login.style';
// import { FeedbackDocumentation } from "./FeedbackDocumentation";
import ClickAwayListener from '@mui/material/ClickAwayListener';
import {
  FeedbackDocumentation,
  TaskPageFeedbackDocumentation,
} from './FeedbackDocumentation';
// import Input from "@mui/base";

const Chat = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.1592 15.9274C14.7294 15.9274 14.3801 15.5782 14.3801 15.1484C14.3801 14.7198 14.7294 14.3706 15.1592 14.3706C15.589 14.3706 15.9382 14.7198 15.9382 15.1484C15.9382 15.5782 15.589 15.9274 15.1592 15.9274ZM12.1306 15.9274C11.7008 15.9274 11.3516 15.5782 11.3516 15.1484C11.3516 14.7198 11.7008 14.3706 12.1306 14.3706C12.5605 14.3706 12.9097 14.7198 12.9097 15.1484C12.9097 15.5782 12.5605 15.9274 12.1306 15.9274ZM17.4088 15.1484C17.4088 15.5782 17.758 15.9274 18.1878 15.9274C18.6177 15.9274 18.9669 15.5782 18.9669 15.1484C18.9669 14.7198 18.6177 14.3706 18.1878 14.3706C17.758 14.3706 17.4088 14.7198 17.4088 15.1484Z"
        fill="#6C2AD2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.012 8.3335C11.1387 8.3335 8.33203 11.4976 8.33203 15.0102C8.33203 16.1319 8.6587 17.2863 9.23203 18.3412C9.3387 18.5154 9.35203 18.7351 9.2787 18.9427L8.83203 20.4383C8.73203 20.7989 9.0387 21.0653 9.3787 20.9584L10.7254 20.5585C11.092 20.4383 11.3787 20.5912 11.7187 20.7989C12.692 21.3724 13.9054 21.6668 14.9987 21.6668C18.3054 21.6668 21.6654 19.1097 21.6654 14.9901C21.6654 11.4375 18.7987 8.3335 15.012 8.3335Z"
        stroke="#6C2AD2"
        stroke-width="0.81025"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        opacity="0.1"
        x="0.5"
        y="0.5"
        width="29"
        height="29"
        rx="4.5"
        stroke="#112347"
      />
    </svg>
  );
};
const Phone = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="0.5"
        y="0.5"
        width="29"
        height="29"
        rx="4.5"
        stroke="#112347"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.6164 11.6322C10.7873 11.3492 11.7287 10.3202 12.4005 10.3513C12.6014 10.3679 12.7789 10.4894 12.9231 10.6303C13.2543 10.9537 14.2024 12.1769 14.2562 12.4343C14.3871 13.0656 13.6349 13.4295 13.8651 14.0658C14.452 15.502 15.4634 16.5132 16.9002 17.0996C17.5359 17.3298 17.8999 16.5776 18.5312 16.7091C18.788 16.7629 20.0118 17.7109 20.3353 18.0421C20.4756 18.1858 20.5977 18.3638 20.6143 18.5646C20.6393 19.2719 19.5464 20.2266 19.3334 20.3487C18.8308 20.7081 18.175 20.702 17.3756 20.3303C15.1449 19.4023 11.58 15.9047 10.6347 13.5898C10.273 12.7949 10.2481 12.1347 10.6164 11.6322Z"
        stroke="#6C2AD2"
        stroke-width="0.81025"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const Location = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.0214 1.66606C6.18054 1.65301 3.04331 4.70881 2.91792 8.53381L2.91406 8.77123C2.9779 10.6461 3.61579 12.4333 4.7393 13.9057L5.00316 14.25C6.07556 15.6136 7.34999 16.8105 8.78096 17.7969L9.12549 18.0289L9.17577 18.0683C9.66623 18.4207 10.3284 18.4207 10.8189 18.0683L10.8607 18.034C11.9962 17.2976 13.0432 16.4324 13.9811 15.4554C15.8879 13.437 17.0372 11.1754 17.0805 8.8785L17.0806 8.79322C17.0937 4.94262 14.0473 1.79574 10.234 1.66992L10.0214 1.66606ZM10.0161 2.93046C13.1648 2.94123 15.7213 5.45709 15.8163 8.59017L15.819 8.86642C15.7825 10.7921 14.7742 12.7763 13.0685 14.5819C12.1988 15.4878 11.2236 16.2931 10.166 16.9779L10.0955 17.0309C10.0385 17.0804 9.95403 17.0804 9.89707 17.0309L9.82856 16.9792C8.25298 15.9505 6.87014 14.6518 5.7433 13.1423C4.83565 11.9527 4.2978 10.5304 4.18954 9.04665L4.17363 8.74913C4.18433 5.59275 6.69244 3.02839 9.81588 2.93317L10.0161 2.93046ZM9.99821 6.16733C8.50788 6.16733 7.29974 7.37921 7.29974 8.87414C7.29974 10.3691 8.50788 11.5809 9.99821 11.5809C11.4885 11.5809 12.6967 10.3691 12.6967 8.87414C12.6967 7.37921 11.4885 6.16733 9.99821 6.16733ZM9.99715 7.43178C10.7913 7.43178 11.435 8.07751 11.435 8.87406C11.435 9.67062 10.7913 10.3163 9.99715 10.3163C9.20305 10.3163 8.5593 9.67062 8.5593 8.87406C8.5593 8.07751 9.20305 7.43178 9.99715 7.43178Z"
        fill="#112347"
      />
    </svg>
  );
};
const ArrowDown = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.03091 12.2803C7.98982 12.2403 7.81416 12.0892 7.66966 11.9484C6.76086 11.1231 5.27336 8.97015 4.81932 7.8433C4.74636 7.67217 4.59195 7.23951 4.58203 7.00834C4.58203 6.78684 4.63303 6.57568 4.73645 6.37419C4.88095 6.12301 5.10832 5.92152 5.37678 5.81111C5.56307 5.74004 6.12053 5.62963 6.13045 5.62963C6.74032 5.51922 7.73128 5.4585 8.82636 5.4585C9.86974 5.4585 10.8203 5.51922 11.4394 5.60962C11.4493 5.61997 12.1421 5.73037 12.3794 5.85113C12.8129 6.07264 13.082 6.5053 13.082 6.96832V7.00834C13.0714 7.30989 12.8022 7.94405 12.7923 7.94405C12.3376 9.01017 10.923 11.1134 9.98307 11.9587C9.98307 11.9587 9.74153 12.1968 9.59066 12.3003C9.37391 12.4618 9.10545 12.5418 8.83699 12.5418C8.53736 12.5418 8.25828 12.4514 8.03091 12.2803Z"
        fill="#112347"
      />
    </svg>
  );
};
// const CustomInput = React.forwardRef(function CustomInput(props, ref) {
//   return (
//     <Input
//       slots={{ input: StyledInputElement, textarea: StyledTextareaElement }}
//       {...props}
//       ref={ref}
//     />
//   );
// });
const blue = {
  100: '#DAECFF',
  200: '#80BFFF',
  400: '#3399FF',
  500: '#007FFF',
  600: '#0072E5',
};

const grey = {
  50: '#F3F6F9',
  100: '#E7EBF0',
  200: '#E0E3E7',
  300: '#CDD2D7',
  400: '#B2BAC2',
  500: '#A0AAB4',
  600: '#6F7E8C',
  700: '#3E5060',
  800: '#2D3843',
  900: '#1A2027',
};

const StyledInputElement = styled('input')(
  ({ theme }) => `
  width: 320px;
  font-family: IBM Plex Sans, sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 12px;
  border-radius: 12px;
  color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
  background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
  border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
  box-shadow: 0px 2px 2px ${
    theme.palette.mode === 'dark' ? grey[900] : grey[50]
  };

  &:hover {
    border-color: ${blue[400]};
  }

  &:focus {
    border-color: ${blue[400]};
    box-shadow: 0 0 0 3px ${
      theme.palette.mode === 'dark' ? blue[500] : blue[200]
    };
  }

  // firefox
  &:focus-visible {
    outline: 0;
  }
`
);

const StyledTextareaElement = styled('textarea', {
  shouldForwardProp: (prop) =>
    !['ownerState', 'minRows', 'maxRows'].includes(prop.toString()),
})(
  ({ theme }) => `
  width: 320px;
  font-family: IBM Plex Sans, sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 12px;
  border-radius: 12px;
  color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
  background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
  border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
  box-shadow: 0px 2px 2px ${
    theme.palette.mode === 'dark' ? grey[900] : grey[50]
  };

  &:hover {
    border-color: ${blue[400]};
  }

  &:focus {
    border-color: ${blue[400]};
    box-shadow: 0 0 0 3px ${
      theme.palette.mode === 'dark' ? blue[500] : blue[200]
    };
  }

  // firefox
  &:focus-visible {
    outline: 0;
  }
`
);

export const TaskPageNoteandFeedback = ({
  expandFeedback,
  setExpandFeedback,
}) => {
  const [value, setValue] = React.useState(0);
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(!open);
    setExpandFeedback(!expandFeedback);
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  const useStyles = makeStyles({
    tab: {
      minHeight: '36.68px', // Set the desired minimum height here
    },
  });

  const classes = useStyles();
  const handleClickOutside = () => {
    setExpandFeedback(!expandFeedback);
  };
  return (
    // <ClickAwayListener onClickAway={handleClickOutside}>
    <div>
      {/* <Dialog
        open={expandFeedback}
        // onClose={!expandFeedback}
        onClose={handleClose}
        PaperProps={{
          sx: {
            top: 100,
            right: 32,
            m: 0,

            minHeight: "90%",
            background: "#FFFFFF",
            boxShadow: "0px 4px 60px rgba(22, 58, 95, 0.07)",
            borderRadius: "4px",
            overflow: "scroll",
          },
        }}
        maxWidth="850px"
      > */}
      <Grid
        container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          padding: '30px',
          gap: '23px',
          width: '763px',
          height: '1182.87px',
        }}
      >
        <Grid
          item
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            padding: '0px',
            height: '131px',
            width: '832px',
            //   bgcolor: "red",
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '0px',
              gap: '20px',
              width: '432px',
              height: '48px',
            }}
          >
            <Box sx={{ width: '94px', height: '48px' }}>
              <Typography
                sx={{ ...poppins600, fontSize: '32px', color: '#262626' }}
              >
                Notes
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-start',
                padding: '0px',
                gap: '15px',

                width: '318px',
                height: '30px',
              }}
            >
              <Button
                variant="outlined"
                sx={{
                  border: '1px solid #6C2AD2',
                  color: '#6C2AD2',
                  ...poppins400,
                  fontSize: '12px',
                  textTransform: 'none',
                }}
              >
                {' '}
                #Buyer
              </Button>
              <Button
                variant="outlined"
                sx={{
                  border: '1px solid  #4CA4D6',
                  color: ' #4CA4D6',
                  ...poppins400,
                  fontSize: '12px',
                  textTransform: 'none',
                }}
              >
                {' '}
                #Owner
              </Button>
              <Button
                variant="outlined"
                sx={{
                  border: '1px solid #666666',
                  color: '#666666',
                  ...poppins400,
                  fontSize: '12px',
                  textTransform: 'none',
                }}
              >
                {' '}
                #Appraisal
              </Button>
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              padding: '0px',
              gap: ' 317px',
              width: '744px',
              height: '83px',
            }}
          >
            <Box>
              <Box
                sx={{
                  width: '125.37px',
                  height: '54.99px',
                  alignItems: 'center',
                  flexDirection: 'row',
                  display: 'flex',
                }}
              >
                <Box>
                  <FeedbackProfile />
                </Box>
                <Box>
                  <Typography
                    sx={{
                      ...poppins400,
                      fontSize: '12px',
                      color: '#112347',
                    }}
                  >
                    {' '}
                    Keil Glass
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  padding: '0px',
                  gap: '5px',
                  // bgcolor: "red",
                  position: 'relative',
                  width: '260px',
                  height: '40px',
                }}
              >
                <Location />
                <Typography
                  sx={{ ...poppins300, fontSize: '12px', color: '#112347' }}
                >
                  {' '}
                  56 Owen Street, North Bondi
                </Typography>
                <ArrowDown />
                {/* <CrossEllipse /> */}
                <Box sx={{ width: '14px', height: '14px', marginTop: '-12px' }}>
                  <CancelOutlinedIcon />
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                padding: '9px 0px',
                gap: '15px',
                width: '75px',
                height: '48px',
              }}
            >
              <Chat />
              <Phone />
            </Box>
          </Box>
        </Grid>
        <Grid
          item
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            padding: '15px',
            gap: '15px',

            width: '832px',
            height: '334.68px',

            background: '#FFFFFF',
            boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.15)',
            bordeRadius: '5px',
          }}
        >
          <Grid
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              padding: '0px',
              gap: '15px',

              width: '832px',
              height: '87.68px',
            }}
          >
            <Box>
              <Tabs
                style={{
                  color: 'purpleHeart',
                  borderBottom: 'purpleheart',
                  display: 'false',
                }}
                value={value}
                onChange={handleChange}
                aria-label=" tabs example"
                sx={{
                  '& .MuiTabs-indicator': {
                    backgroundColor: '#fffff',
                    marginBottom: '5px',
                  },
                  '& .MuiTab-root.Mui-selected': {
                    color: '#2F74EE',
                    background: 'rgba(0, 101, 252, 0.1)',
                    //   borderBottom: "1px solid #2F74EE",
                    width: '67.13px',
                    height: '36.68px',
                    p: '0px',
                  },
                }}
              >
                <Tab
                  style={{ minHeight: '39.68px', padding: '0px' }}
                  className={classes.tab}
                  label="Notes"
                  {...a11yProps(0)}
                  sx={{
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: '400 !important',
                    fontSize: '12px',
                    textTransform: 'capitalize',
                  }}
                />

                <Tab
                  style={{ minHeight: '39.68px', padding: '0px' }}
                  className={classes.tab}
                  label="Task"
                  {...a11yProps(1)}
                  sx={{
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: '400 !important',
                    fontSize: '12px',
                    // color: "#9A9A9F",
                    textTransform: 'none',
                  }}
                />
              </Tabs>
              <TabPanel value={value} index={0}></TabPanel>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '0px',
                gap: '10px',

                width: '830px',
                height: '36px',
              }}
            >
              {/* <Box
                  sx={{
                    width: 592,

                    maxWidth: "100%",
                    p: "0px",
                    // padding: "6.5px 7px",
                  }}
                >
                  <TextField
                    sx={{ width: "592px", height: "36px", p: "0px" }}
                  />
                </Box> */}
              <Box
                component="form"
                sx={{
                  p: '2px 4px',
                  display: 'flex',
                  alignItems: 'center',
                  width: '800px',
                  backgroundColor: '##FFFFFF',
                  border: ' 0.5px solid #D9D9D9',
                  borderRadius: '5px',
                  height: '36px',
                }}
              >
                <InputBase
                  sx={{
                    ml: 1,
                    flex: 1,
                    '& ::placeholder': {
                      color: '#8B8B8B',
                      fontSize: '14px',
                      fontWeight: 400,
                      fontFamily: 'poppins',
                      opacity: 1,
                    },

                    fontSize: '14px',
                    fontWeight: 400,
                    fontFamily: 'poppins',
                    color: '#8B8B8B',
                  }}
                  placeholder="Subject"
                  inputProps={{
                    'aria-label': 'Subject',
                  }}
                />
              </Box>
              <Box>
                <Select
                  sx={{
                    ...poppins400,
                    fontSize: '12px',
                    color: '#666666',
                    border: '0.5px solid #D9D9D9',
                    borderRadius: '4px',
                    height: '36px',
                    width: '126px',
                    background: '#FFFFFF',
                    p: '0px',
                  }}
                  size="small"
                  value="10"
                  style={
                    {
                      //   marginTop: "3px",
                    }
                  }
                  onChange={() => {}}
                  displayEmpty
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  <MenuItem value={10} padding={'none'}>
                    vendor Report
                  </MenuItem>
                  <MenuItem value={20}>Twenty</MenuItem>
                  <MenuItem value={30}>Thirty</MenuItem>
                </Select>
              </Box>
            </Box>
          </Grid>
          <Grid item sx={{ marginTop: '6px' }}>
            <TextField
              variant="standard"
              multiline
              rows={5}
              InputProps={{ disableUnderline: true }}
              style={{
                width: '832px',
                height: '153px',
                padding: '12px 0px 12px 15px',
              }}
              placeholder="Details"
              sx={{
                '& ::placeholder': {
                  color: '#8B8B8B',
                  fontSize: '14px',
                  fontWeight: 400,
                  fontFamily: 'poppins',
                  opacity: 1,
                },
                border: '0.5px solid #D9D9D9',
                borderRadius: '5px',
                background: '#FFFFFF',
              }}
            />
          </Grid>
          <Grid
            item
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              alignItems: 'center',
              padding: '0px',
              gap: '5px',
              marginLeft: '8px',
              width: '832px',
              height: '34px',
            }}
          >
            <Box>
              <Typography
                sx={{
                  ...poppins400,
                  fontSize: '12px',
                  lineHeight: '18px',
                  color: '#000000',
                }}
              >
                Tags -
              </Typography>
            </Box>
            <Box>
              <Box
                sx={{
                  width: '69px',
                  height: '17px',

                  background: '#0BC4ED',
                  borderRadius: ' 5px',
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'flex-start',
                  padding: '1px 10px',
                }}
              >
                <Typography
                  sx={{ color: '#FFFFFF', ...poppins500, fontSize: '10px' }}
                >
                  #Public
                </Typography>
              </Box>
            </Box>
            <Box>
              <Button
                sx={{
                  width: '153px',
                  height: '34px',
                  border: '0.5px solid #D9D9D9',
                  bordeRadius: '5px',
                  minWidth: '153px',
                  p: '0px',
                }}
              >
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '12px',
                    color: '#272727',
                    textTransform: 'none',
                  }}
                >
                  + Insert Template Text
                </Typography>
              </Button>
            </Box>
            <Box>
              <Typography style={{ paddingRight: '10px' }}>
                <Button
                  // variant="contained"
                  sx={{
                    width: '86px',
                    ...poppins400,
                    fontSize: '12px',
                    color: '#6C2AD2',
                    height: '35px',
                    background: '#ECE5F6',
                    borderRadius: ' 5px',
                    textTransform: 'none',
                  }}
                >
                  Add Note
                </Button>
              </Typography>
            </Box>
          </Grid>
          {/* <Grid item>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  padding: "0px",
                  gap: "30px",

                  width: "763px",
                  height: "19px",

                  marginTop: "23px",
                  marginLeft: "-70px",
                }}
              >
                <Box>
                  <Checkbox {...label} />
                  <Typography
                    sx={{
                      ...poppins400,
                      fontSize: "12px",
                      color: "#737497",
                      lineHeight: "18px",
                    }}
                  >
                    Schedule follow up?
                  </Typography>
                </Box>
                <Box>
                  <Checkbox {...label} />
                  <Typography
                    sx={{
                      ...poppins400,
                      fontSize: "12px",
                      color: "#737497",
                      lineHeight: "18px",
                    }}
                  >
                    Mark as done
                  </Typography>
                </Box>
              </Box>
            </Grid> */}
          <Grid item>
            <FeedbackDocumentation />
          </Grid>
        </Grid>
      </Grid>
      {/* </Dialog> */}
    </div>
    // </ClickAwayListener>
  );
};
